import styled from 'styled-components'

export const ButtonPanelContainer = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 1.5rem 1.625rem 1.5rem;
  box-shadow: 0 -0.0625rem 0 ${props => props.theme.palette.gray[200]};
  z-index: 1000;
  max-width: 24.5625rem;
  margin: 0 auto;
  height: 5.5rem;

  @media screen and (max-width: 37.5rem) {
    width: 100%;
    max-width: none;
    padding: 0.5rem 1rem;
  }
`

export const NavButton = styled.button<{ $active?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: none;
  cursor: pointer;
  /* transition: color 0.2s ease; */
  padding: 0;
  height: 3.25rem;
  width: 4.25rem;

  span {
    ${({ theme, $active }) => `
      color: ${$active ? theme.palette.primary[400] : theme.palette.gray[400]};
    `}
  }
`

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
`
